import { type FC } from 'react';
import { AnimatePresence } from 'framer-motion';

import { selectFullscreenModalsList } from '@/redux/selectors/modalsSelector';
import { useAppSelector } from '@/redux/store';

import { DynamicModal } from './DynamicModal/DynamicModal';

const FullscreenModals: FC = () => {
  const modalsList = useAppSelector(selectFullscreenModalsList);

  return (
    <AnimatePresence>
      {modalsList.map((props) => (
        <DynamicModal key={props.name} {...props} />
      ))}
    </AnimatePresence>
  );
};

export { FullscreenModals };
